//#region Import Zone
import { Component, OnInit, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location} from '@angular/common';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api/api.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EventsService } from 'src/app/services/events.service';
import { DataService } from 'src/app/services/data/data.service';
import { PageNavigateService } from 'src/app/services/page-navigate/page-navigate.service';
import { _ } from 'underscore';
import { NgxAlertsService } from '@ngx-plus/ngx-alerts';
import { config } from '../../app.config';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { OneSignalService } from 'src/app/services/onesignal/one-signal.service';
import { ShareData } from 'src/app/app.share-data';
import { UtilitysService } from 'src/app/services/utilitys/utilitys.service';

//#endregion

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  //#region Variable Zone
  public profile: any = {};
  public listTitles: any[];
  public location: Location;

  notifications: any;
  modalRef: BsModalRef;
  configmodal = { class: 'service-modal' };
  currPoint;
  ServiceList;
  AllServiceList;
  profileImg;
  Badge = 0;
  visitorSummary: any;
  visitorSummaryTotal = 0;
  visitorSummaryLastUpdate = new Date();
  currServiceCode = 'A0018';
  mrkpModel: any = {};
  isMrkp = false;

  @ViewChild("dropdownMenu", {static: true}) dropdownMenu: any;
  @ViewChild("serviceModal", {static: true}) serviceModal: ElementRef;

  public item: any[] = [
    {
      Name: 'Hybrid Classroom',
      Url_img: 'assets/img/icons/services/000-hybrid-classroom.png',
    },
    {
      Name: 'E-Library',
      Url_img: 'assets/img/icons/services/100-e-library.png',
    },
    {
      Name: 'Today News',
      Url_img: 'assets/img/icons/services/010-today-news.png',
    },
    {
      Name: 'Group5',
      Url_img: 'assets/img/icons/services/020-group5.png',
    },
    {
      Name: 'Lifestyle',
      Url_img: 'assets/img/icons/services/050-lifestyle.png',
    },
    {
      Name: 'Innovation Corner',
      Url_img: 'assets/img/icons/services/030-innovation.png',
    },
    {
      Name: 'Marketing',
      Url_img: 'assets/img/icons/services/040-market.png',
    },
    {
      Name: 'HR Room',
      Url_img: 'assets/img/icons/services/060-hr-room.png',
    },
    {
      Name: 'KM Club',
      Url_img: 'assets/img/icons/services/070-km-club.png',
    },
    {
      Name: 'Quality Room',
      Url_img: 'assets/img/icons/services/080-quality-room.png',
    },
    {
      Name: 'Language Club',
      Url_img: 'assets/img/icons/services/090-language.png',
    },
    {
      Name: 'Live',
      Url_img: 'assets/img/icons/services/110-live.png',
    },
    {
      Name: 'Reward Store',
      Url_img: 'assets/img/icons/services/130-reward.png',
    }
  ];
  //#endregion

  //#region Contructor Zone
  constructor(
    location: Location,
    private router: Router,
    private modalService: BsModalService,
    private api: ApiService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private eventsService: EventsService,
    public dataService: DataService,
    private pageNavigateService: PageNavigateService,
    private noti: NotificationService,
    private alert: NgxAlertsService,
    private onesignal: OneSignalService,
    private utility: UtilitysService
    // private activatedRoute: ActivatedRoute,
  ) {
    try {
      this.location = location;
      this.getAllService();

      this.onVisitorSummary();
      setInterval(() => this.onVisitorSummary(), 300000);

      this.eventsService.onMrkpNavs.subscribe(res => {
        // console.log(res);
        this.mrkpModel = res;
      });

      this.router.events.subscribe(res => {
        // console.log(res);
        if((window.location.href).indexOf('/marketplace') == -1) {
          this.isMrkp = false;
        } else {
          this.isMrkp = true;
        }
      });
    } catch (err) {
      // this.alert.alertError(JSON.stringify(err));
      console.error(err);
    }
  }
  //#endregion

  //#region Functions Implement Zone
  ngOnInit() {
    try {
      this.listTitles = ROUTES.filter(listTitle => listTitle);
      this.getMyProfile();
      this.getNotificationList();
      this.noti.notificationCount();
     
      //this.onesignal.initOneSignal();

      this.eventsService.onPointSubscribe.subscribe(point => {
        if(point){
          this.currPoint = point;
        }
      });

      this.eventsService.onReloadMyProfile.subscribe(() => {
        this.getMyProfile(true);
      });

      this.eventsService.onProfileImgSubscribe.subscribe(img => {
        if(img){
          this.profileImg = img;
        }
      });

      this.eventsService.onNotificationCount.subscribe(res => {
        // console.log("res");
        if(res){
          this.Badge = res || 0;
        }
      }, err => {
        throw err;
      });
    } catch (err) {
      // this.alert.alertError(JSON.stringify(err));
      console.error(err);
    }
  }
  //#endregion

  //#region Functions Utility Zone
  async getMyProfile(forceRefresh = false) {
    try {
      this.profile = await this.utility.getMyProfile(true, true, true, forceRefresh);
        // this.profile = res.Results;
        if(this.profile && 'CurrentPoint' in this.profile){
          this.eventsService.onPointSubscribe.emit(this.profile.CurrentPoint);
        }

        if(this.profile && 'AvatarURL' in this.profile){
          this.eventsService.onProfileImgSubscribe.emit(this.profile.AvatarURL);
        }
    } catch (err) {
      // throw err;
    }
    
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.configmodal);
  }

  getTitle() {
    try {
      let titlee = this.location.prepareExternalUrl(this.location.path());
      if (titlee.charAt(0) === '#') {
        titlee = titlee.slice(1);
      }

      for (let item = 0; item < this.listTitles.length; item++) {
        if (this.listTitles[item].path === titlee) {
          return this.listTitles[item].title;
        }
      }
      return '';
    } catch (err) {
      throw err;
    }
    
  }

  signout() {
    window.localStorage.clear();
    this.router.navigate(['/signin']);
  }

  getBadge() {
    // this.eventsService.onNotificationCount.emit(window.localStorage.getItem('badgeNotification') ? Number(window.localStorage.getItem('badgeNotification')) : 0);
  }

  refresh() {
    location.reload();
  }

  getNotificationList() {
    this.api.notificationListing().subscribe((res: any) => {
      this.notifications = res.Results;
    });
  }

  readNotificationAll() {
    this.ngxUiLoaderService.start();
    this.api.notificationReadingAll().subscribe(() => {
      this.noti.notificationCount();
      this.getNotificationList();
      this.ngxUiLoaderService.stopAll();
    }, (err: any) => {
      console.table(err);
      this.ngxUiLoaderService.stopAll();
    });
  }

  getAllService() {
    try {
      this.dataService.load().then(() => {
        if(this.dataService && 'listService' in this.dataService){
          this.AllServiceList = this.dataService.allListService;
          this.ServiceList = this.dataService.listService;
          // console.log(this.dataService);
        }
      }, () => {
      });
    } catch (err) {
      throw err;
    }
  }

  openService(service: any) {
    this.pageNavigateService.navigate(service);
    window.event.stopPropagation();
  }

  filter(str: any) {
    try {
      console.log(str)
      if(str){
        this.AllServiceList = _.filter(this.dataService.allListService, function(listService){ return listService.ServiceName.toLowerCase().includes(str.toLowerCase()); });
      } else {
        this.AllServiceList =  this.dataService.allListService;
      }
      
    } catch (err) {
      alert(err);
    }
  }

  onClickNotification(item: any, isToday: number){
    try{
      // console.log(item);
      ShareData.currentService = item;
      item.isToday = isToday;
      if (item && ('MessageID' in item) && item.MessageID) {
        this.ngxUiLoaderService.start();
        this.api.notificationReading(config.oneSignalID, item.MessageID).subscribe((res: any) => {
          if(res.Code === 200){
            this.getNotificationList();
            this.noti.notificationCount();
            this.pageNavigateService.navigate(item);
          } else {
            this.alert.alertError({title: res.Message});
          }
          this.ngxUiLoaderService.stopAll();
        }, (err: any) => {
          this.ngxUiLoaderService.stopAll();
          if (err.statusText) {
            return this.alert.alertError({title: err.statusText});
          }
          this.alert.alertError({title: `Internal error please contact admin`});
        });
      }
    } catch (err) {
      alert(err);
    }
  }

  onBellNotificationClick(item: any) {
    this.getNotificationList();
    this.noti.notificationCount();
  }

  onServiceLock() {
    try {
      this.alert.alertWarning({title: `
      <h1>Forbidden</h1>
      <div>You don't have permission to access on this service.</div>
      `});
    } catch (err) {
      alert(err);
    }
  }

  onVisitorSummary() {
    try {
      this.api.getVisitorSummary().subscribe(res => {
        // console.log(res);
        if(res && res.Code == 200) {
          this.visitorSummary = res.Results;
          this.visitorSummaryTotal = parseInt(this.setDamical2Digit(this.visitorSummary.Total));
          this.visitorSummaryLastUpdate = new Date();
        }
      }, err => {

      });
    } catch (err) {
      throw err;
    }
  }

  setDamical2Digit(num: any){
    return (Math.round( (num / 1000) * 100 ) / 100).toFixed(1);
  }

  gotoStore() {
    this.dataService.mrkpProductInfo.MerchantId = this.mrkpModel.MerchantId;
    this.router.navigate(['/marketplace-store', 2]);
  }

  gotoRegister() {
    this.router.navigate(['/marketplace/custom-store', 1]);
  }

  gotoEditProduct(){
    this.router.navigate(['/marketplace/product'], { queryParams: { type: 3, product: this.mrkpModel.productId }});
  }

  mrkpHomeClick(mrkp: any) {
    this.router.navigate(['/marketplace/home']);
  }

  gotoViewProductHistory() {
    this.router.navigate(['/marketplace/review-history'], { queryParams: {type: 1}});
  }

  //#endregion

}
